import styled from 'styled-components';
import { Label } from '@mlc/web-ui-toolkit';
import { ScreenSize } from '../../../../enums';

export const Li = styled.li`
	flex-grow: 1;
	height: auto;
	list-style: none;
	margin: 0;
	padding: 0;
	position: relative;
	text-align: left;

	@media (max-width: ${ScreenSize.medium}) {
		flex: none;
		text-align: left;
		width: 25%;
	}

	@media (max-width: ${ScreenSize.small}) {
		text-align: left;
		width: 33%;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		text-align: left;
		width: 50%;
	}
`;

export const LinkContent = styled.div`
	align-items: baseline;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	margin-bottom: 0;
	margin-top: 0;
`;

export const LinkText = styled(Label)`
	color: inherit;
	cursor: pointer;
	display: flex;
	flex-shrink: 0;
	flex-wrap: nowrap;
	line-height: 2;
	margin-bottom: 0;
	margin-top: 0;

	@media (max-width: ${ScreenSize.small}) {
		line-height: 1.8 !important;
	}
`;
